import { jsx as _jsx } from "react/jsx-runtime";
import cx from "classnames";
import { useState } from "react";
import Img from "react-cool-img";
import { toolkitCx } from "../../../constants/classnames";
/**
 * A component that renders an image with additional features, such as a placeholder while the image loads and a pulse animation when the image is loading.
 * @param {object} props - The props object.
 * @param {string} props.alt - The image description for accessibility.
 * @param {string} [props.className] - The optional class name to apply to the image.
 * @param {number} [props.height] - The height of the image.
 * @param {string} props.src - The source URL for the image.
 * @param {number} [props.width] - The width of the image.
 * @param {ImgProps} [props.withPlaceholder] - Whether to show a placeholder while the image loads.
 * @param {ImgProps} [props.imageProps] - Additional props to pass to the underlying react-cool-img component.
 * @returns {JSX.Element} - The Image component.
 */
const Image = ({ alt, className, height, src, width, withPlaceholder = true, ...imageProps }) => {
    const [loaded, setLoaded] = useState(false);
    // placeholder with text-primary/10 as fill
    const placeholderSrc = `data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" stroke="rgba(10 147 236 / 0.1" viewBox="0 0 24 24" stroke-width="1.5" fill="none"><path stroke-linecap="round" stroke-linejoin="round" d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" /></svg>
`;
    return (_jsx(Img, { ...imageProps, alt: alt, className: cx(className, "bg-gray-200/30 dark:bg-gray-800/40", toolkitCx.layout.transition.colors, {
            "rounded-lg motion-safe:animate-pulse": !loaded,
            "rounded-none !bg-transparent object-cover": loaded,
        }), onLoad: () => setLoaded(true), src: src, width: width, ...(width &&
            height && {
            style: { aspectRatio: width / height },
        }), ...(withPlaceholder && {
            placeholder: placeholderSrc,
        }) }));
};
export default Image;
//# sourceMappingURL=Image.js.map